// JsFromRoutes CacheKey 777a79318f9127b21c1e70f54998e424
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/style_guide'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:org_nano_id/style_guide'),
}
